export const styles = {
    appBar: {
        backgroundColor: '#FFF',
        width: '100%',
        overflow: 'hidden',
        color: '#333'
    },
    backButton: {
        color: '#333',
    },
    closeButton: {
        color: '#333'
    },
    closeButtonWrapper: {
        textAlign: 'right',
    },
    content: {
        padding: '0px 5px',
        lineHeight: 1.6,
        color: '#001233',
    },
    contentWrapper: {
        padding: '17px 14px',
        fontWeight: 500,
    },
    title: {
        textAlign: 'center',
        width: '100%',
        fontWeight: 700,
    }
};